import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useGoogleInfo, useRevokeGoogle} from "@mytour/platform";
import {Button} from "reactstrap";
export function Step1() {
  const {googleInfo} = useGoogleInfo();
  const {revokeGoogle, isRevoking} = useRevokeGoogle();
  if (googleInfo?.userinfo) {
    return (
      <div>
        <p>
          <FontAwesomeIcon icon="check" /> <strong>{"Compte Google Agenda trouvé"}</strong>
        </p>
        <p style={{marginLeft: "8px"}}>
          <img width="20px" src={googleInfo.userinfo.picture} /> {googleInfo.userinfo.email}
        </p>
        {!googleInfo.hasGoogleCalendar && (
          <div className={"alert alert-warning"}>
            <p>
              <strong>{`MyTour ne peut pas synchroniser l'agenda google`}</strong>
              <br />
              {`Vous n'avez pas donné l'autorisation au moment de la connexion avec Google.`}
              <br />
              {"Pour activer cette fonctionnalité, vous pouvez cliquer sur"}{" "}
              <strong>{"réinitialiser"}</strong>
              {"."}
            </p>
          </div>
        )}

        <Button
          color="primary"
          type="submit"
          disabled={isRevoking}
          onClick={() => {
            revokeGoogle();
          }}
        >
          Réinitialiser
        </Button>
      </div>
    );
  }
  return (
    <div>
      <p>
        <strong>Sélectionner un compte Google</strong>
      </p>
      <p>Pour activer la synchronisation, vous devez choisir un compte Google.</p>
    </div>
  );
}
